/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} App_Endpoint_Free_Sample_NoteInputs */

const en_app_endpoint_free_sample_note = /** @type {(inputs: App_Endpoint_Free_Sample_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A capped run on the house. It does not touch your wallet.`)
};

const zh_hans1_app_endpoint_free_sample_note = /** @type {(inputs: App_Endpoint_Free_Sample_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`一次有上限的免费运行，由我们承担费用，不会动用你的钱包。`)
};

const pt_br2_app_endpoint_free_sample_note = /** @type {(inputs: App_Endpoint_Free_Sample_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Uma execução limitada por nossa conta. Não mexe na sua carteira.`)
};

const es_app_endpoint_free_sample_note = /** @type {(inputs: App_Endpoint_Free_Sample_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Una ejecución limitada por nuestra cuenta. No toca tu billetera.`)
};

const fr_app_endpoint_free_sample_note = /** @type {(inputs: App_Endpoint_Free_Sample_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Une exécution plafonnée offerte par la maison. Elle ne touche pas à votre portefeuille.`)
};

const de_app_endpoint_free_sample_note = /** @type {(inputs: App_Endpoint_Free_Sample_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ein begrenzter Lauf auf unsere Kosten. Er berührt dein Guthabenkonto nicht.`)
};

const ru_app_endpoint_free_sample_note = /** @type {(inputs: App_Endpoint_Free_Sample_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ограниченный запуск за наш счёт. Кошелёк не затрагивается.`)
};

const it_app_endpoint_free_sample_note = /** @type {(inputs: App_Endpoint_Free_Sample_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Un'esecuzione limitata offerta da noi. Non tocca il tuo portafoglio.`)
};

/**
* | output |
* | --- |
* | "A capped run on the house. It does not touch your wallet." |
*
* @param {App_Endpoint_Free_Sample_NoteInputs} inputs
* @param {{ locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }} options
* @returns {LocalizedString}
*/
export const app_endpoint_free_sample_note = /** @type {((inputs?: App_Endpoint_Free_Sample_NoteInputs, options?: { locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<App_Endpoint_Free_Sample_NoteInputs, { locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh-Hans") return zh_hans1_app_endpoint_free_sample_note(inputs)
	if (locale === "pt-BR") return pt_br2_app_endpoint_free_sample_note(inputs)
	if (locale === "es") return es_app_endpoint_free_sample_note(inputs)
	if (locale === "fr") return fr_app_endpoint_free_sample_note(inputs)
	if (locale === "de") return de_app_endpoint_free_sample_note(inputs)
	if (locale === "ru") return ru_app_endpoint_free_sample_note(inputs)
	if (locale === "it") return it_app_endpoint_free_sample_note(inputs)
	return en_app_endpoint_free_sample_note(inputs)
});